import { render } from "./CtaShow.vue?vue&type=template&id=0d8e9291&ts=true"
import script from "./CtaShow.vue?vue&type=script&lang=ts"
export * from "./CtaShow.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/bizerba/bizerba-web/light-modules/bizerba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__